






import Vue from 'vue'

export default Vue.extend({
  name: 'AriaLive',
  props: {
    level: {
      type: String,
      default: 'polite',
    },
  },
  data() {
    return {
      message: '',
    }
  },
  methods: {
    announce(text: string): void {
      this.message = ''
      // NVDA等で同一文言が連続すると読み上げられないことがあるため、
      // 空文字をセットしてから一定時間空けて文言をセットする
      setTimeout(() => {
        this.message = text
      }, 1000)
    },
  },
})
